export default {
  // मोड्स
  "common.mode.auto": "स्वचालित मोड (स्वयं उत्पन्न ऊर्जा का उपयोग)",
  "common.mode.economy": "अर्थव्यवस्थिक मोड",
  "common.mode.exigency": "आपातकालीन मोड",

  // उपकरण
  "common.grid": "विद्युत ग्रिड",
  "common.evChargers": "इलेक्ट्रिक कार चार्जर्स (अनेक)",
  "common.evCharger": "इलेक्ट्रिक कार चार्जर",
  "common.pv": "सौर ऊर्जा (PV)",
  "common.inverter": "इन्वर्टर (वोल्टेज रूपांतरण उपकरण)",
  "common.pcs": "इन्वर्टर + बैटरी",
  "common.terminal": "टर्मिनल उपकरण",
  "common.airc": "एयरकंडीशनर (AC)",
  "common.engine": "इंजन",
  "common.battery": "बैटरी",
  "common.metter": "विद्युत मीटर",
  "common.other": "अन्य",
  "common.power": "शक्ति",
  "common.powerTotal": "कुल शक्ति",
  "common.voltage": "वोल्टेज",
  "common.electricity": "विद्युत",
  "common.current": "धारा",
  "common.homeUsage": "कुल घरेलू भार",
  "common.battery.power": "बैटरी शक्ति",

  // डेटा
  "common.noDataAvailable": "वर्तमान में डेटा उपलब्ध नहीं है~",
  "common.tips": "सुझाव",
  "common.reset": "रीसेट (मिटाना)",
  "common.currencyUnit": "¥ (युआन)",
  "common.submiting": "प्रस्तुत कर रहा हूं... कृपया प्रतीक्षा करें...",
  "common.close": "बंद करें",
  "common.from": "से",
  "common.useIn": "के लिए",
  "common.energyPercent": "ऊर्जा उपयोग प्रतिशत",
  "common.dataFlow": "डेटा प्रवाह",
  "common.getDataIng": "डेटा प्राप्त कर रहा हूं... कृपया प्रतीक्षा करें...",
  "common.pageLoading": "पृष्ठ लोड हो रहा है... कृपया प्रतिशत करें...",
  "common.reseting": "पृष्ठ रीसेट हो रहा है... कृपया प्रतीक्षा करें...",
  "common.save": "सहेजें",
  "common.onlyNumberTips": "केवल संख्याएं दर्ज की जा सकती हैं",
  "common.offline": "ऑफलाइन (इंटरनेट से नहीं जुड़ा हुआ)",
  "common.online": "ऑनलाइन (इंटरनेट से जुड़ा हुआ)",
  "common.fault": "त्रुटि (समस्या)",
  "common.charge": "चार्ज (बैटरी)",
  "common.discharge": "डिस्चार्ज (बैटरी ऊर्जा का उपयोग)",
  "common.buy": "खरीदना",
  "common.sell": "बेचना",
  "common.loadingInfo": "लोड हो रहा है... कृपया प्रतीक्षा करें...",

  // सामान्य कार्यक्षमता
  "common.moreFeatures": "अधिक सुविधाएं",
  "common.confirm": "पुष्टि करें",
  "common.saveing": "सहेज रहा हूं... कृपया प्रतीक्षा करें...",
  "common.searchPlacholder": "खोज के लिए कीवर्ड दर्ज करें",
  "common.iSee": "मैं समझ गया हूं",
  "common.pageErrorTips1": "ओह, पृष्ठ में त्रुटि आई है~",
  "common.pageErrorTips2": "पृष्ठ को रिफ्रेश करें या सहायता टीम से संपर्क करें~",
  "common.refresh": "रिफ्रेश",
  "common.backToHome": "होम पेज पर लौटें",
  "common.checkTips": "जांच कर रहा हूं... कृपया प्रतीक्षा करें...",
  "common.back": "वापस जाएं",
  "common.cancel": "रद्द करें (मिटाना)",
  "common.optional": "वैकल्पिक (अनिवार्य नहीं)",
  "common.required": "दर्ज करने के लिए अनिवार्य",
  "common.status": "स्थिति",
  "common.statusNoDelete": "मिटाया नहीं गया",
  "common.statusDelete": "मिटाया गया",
  "common.submit": "प्रस्तुत करें",
  "common.disable": "अक्षम करें",
  "common.enable": "सक्षम करें",
  "common.year": "वर्ष",
  "common.month": "महीना",
  "common.day": "दिन",
  "common.version": "संस्करण:",
  "common.backHome": "होम पेज पर लौटें",
  "common.backHomeSorry": "क्षमा करें, यह पृष्ठ अमान्य है",
  "common.requestTips1": "डेटा प्राप्त करने की प्रक्रिया चल रही है, फिर से प्रस्तुत न करें",
  "common.requestTips2": "सिस्टम सूचनाएं",
  "common.requestTips3": "लॉगिन सत्र समाप्त हो गया है, फिर से लॉगिन करें",
  "common.requestTips4": "फिर से लॉगिन",
  "common.requestTips5": "लॉगिन अमान्य है या सत्र समाप्त हो गया है, फिर से लॉगिन करें।",
  "common.requestTips6": "सर्वर में त्रुटि, कृपया बाद में फिर से प्रयास करें.",
  "common.requestTips7": "सिस्टम अनुरोध समय समाप्त हो गया",
  "common.requestTips8": "सिस्टम इंटरफेस",
  "common.requestTips9": "त्रुटि",
  "common.iknow": "मैं समझ गया हूं",
  "common.logoutSuccess": "लॉगआउट सफल हुआ",
  
  // अधिक जानकारी अनुभाग
  "common.knowMore.title": "अधिक जानकारी के लिए, Beineng के साथ संपर्क करें",
  "common.knowMore.email": "संपर्क के लिए ईमेल",
  "common.knowMore.phone": "संपर्क के लिए फोन नंबर",
  "common.knowMore.wechat": "संपर्क के लिए व्हाट्सएप (WeChat)",
  "common.knowMore.website": "आधिकारिक वेबसाइट पता",
  "common.knowMore.address": "संपर्क के लिए पता",
  "common.knowMore.addressDetail": "ग्वांगडोंग प्रांत, डोंगगुआन शहर, हुआंगजiang टाउन, हुआंगजिंगकेंग गांव, किंग्सी 8 रोड, 5 बिल्डिंग, 1205 रूम, 1301 रूम",
  
  // स्थानीय कनेक्शन
  "common.localConnection": "स्थानीय कनेक्शन",
  "common.operateInApp": "ऐप में ऑपरेशन करें!",
  
  "common.enbleStaus": "सक्षम स्थिति",
  "common.battery.status": "चार्ज नहीं हो रहा, डिस्चार्ज नहीं हो रहा",

  // खाते से संबंधित
  "account.forgetThePassword": "पासवर्ड भूल गए हैं",
  "account.logInDirectly": "सीधे लॉगिन",
  "account.tips1": "पृष्ठ पर स्थानांतरित हो रहा है... कृपया प्रतीक्षा करें...",
  "account.tips2": "पहले उपयोग शर्तें पढ़ें और स्वीकार करें!",
  "account.autoLogin": "स्वचालित लॉगिन",
  "account.userLogin": "उपयोगकर्ता लॉगिन",
  "account.registerTips": "क्या आपके पास खाता नहीं है? पंजीकरण के लिए यहां क्लिक करें",
  "account.userEmail": "उपयोगकर्ता नाम / ईमेल",
  "account.userEmailTips": "उपयोगकर्ता नाम या ईमेल दर्ज करें",
  "account.password": "पासवर्ड",
  "account.passwordTips": "पासवर्ड दर्ज करें",
  "account.submit": "प्रस्तुत करें",
  "account.submitTips": "प्रस्तुत कर रहा हूं... कृपया प्रतीक्षा करें...",
  "account.otherLoginTips": "या कोई अन्य लॉगिन तरीका चुनें",
  "account.userRegistration": "उपयोगकर्ता पंजीकरण",
  "account.userName": "उपयोगकर्ता नाम",
  "account.userNameTips": "उपयोगकर्ता नाम दर्ज करें",
  "account.emailTips1": "ईमेल पता दर्ज करें",
  "account.emailTips2": "अमान्य ईमेल प्रारूप",
  "account.phone": "फोन",
  "account.phoneTips1": "फोन नंबर दर्ज करें",
  "account.phoneTips2": "अमान्य फोन नंबर",
  "account.phoneTips3": "फोन नंबर दर्ज करें",
  "account.passwordTips1": "पासवर्ड दर्ज करें (6-30 वर्ण)",
  "account.passwordTips2": "अमान्य पासवर्ड प्रारूप: पासवर्ड में अंग्रेजी अक्षर, संख्याएं, अंडरस्कोर (_), हाइफन (-) और डॉट (.) शामिल होने चाहिए, लंबाई 6-12 वर्ण होनी चाहिए",
  "account.passwordTips3": "दो दर्ज किए गए पासवर्ड मेल नहीं खा रहे हैं, कृपया जांचें और फिर से दर्ज करें!",
  "account.passwordTips4": "पासवर्ड दर्ज करें: पासवर्ड में अंग्रेजी अक्षर, संख्याएं, अंडरस्कोर (_), हाइफन (-) और डॉट (.) शामिल होने चाहिए",
  "account.passwordTips5": "पासवर्ड की पुष्टि",
  "account.passwordTips6": "पासवर्ड की पुष्टि के लिए दर्ज करें",
  "account.passwordTips7": "दो दर्ज किए गए पासवर्ड मेल नहीं खा रहे हैं, कृपया जांचें और फिर से दर्ज करें!",
  "account.passwordTips8": "पासवर्ड की पुष्टि के लिए दर्ज करें",
  "account.passwordTips9": "बधाई हो, पंजीकरण सफल हुआ!",
  "account.passwordTips10": "आपका उपयोगकर्ता नाम है:",
  "account.emailIs": "आपका ईमेल है:",
  "account.goToLoginPage": "s सेकंड के बाद स्वचालित रूप से लॉगिन पृष्ठ पर जाएगा",
  "account.goLogin": "लॉगिन",
  "account.goRegister": "पंजीकरण",
  "account.loginSuccess": "लॉगिन सफल हुआ",
  "account.email": "ईमेल",
  "account.sologn": "हम आपके लिए विशेष रूप से डिज़ाइन किए गए एक एकीकृत ऊर्जा प्लेटफॉर्म प्रदान करते हैं",
  "account.pleaseAgree": "मैंने उपयोग शर्तें पढ़ी हैं और स्वीकार की हैं",
  "userAgreement.privacyPolicy": "गोपनीयता नीति",

  // प्रमाणीकरण कोड से संबंधित
  "account.code": "प्रमाणीकरण कोड",
  "account.codeTips": "प्रमाणीकरण कोड दर्ज करें",
  "account.codeTips2": "अमान्य प्रमाणीकरण कोड",

    "account.inviteCodeTips": "कृपया आमंत्रण कोड दर्ज करें",
    "account.inviteCodeHint": "आमंत्रण कोड प्राप्त करने के लिए कृपया इंस्टॉलर या संचालन और रखरखाव कर्मियों से संपर्क करें",
  // पासवर्ड बदलने और पुनर्प्राप्त करने से संबंधित
  "account.modifyPasswordByAccount": "खाते के माध्यम से पासवर्ड बदलें",
  "account.modifyPasswordByEmail": "ईमेल के माध्यम से पासवर्ड बदलें",
  "account.getPasswordByAccount": "खाते के माध्यम से पासवर्ड प्राप्त करें",
  "account.getPasswordByEmail": "ईमेल के माध्यम से पासवर्ड प्राप्त करें",

  "account.sendEmailTips": "प्रमाणीकरण कोड ईमेल पर भेजा गया है, कृपया जांचें",
  "account.name": "खाता नाम",
  "account.newPassword": "नया पासवर्ड",
  "account.confirmNewPassword": "नए पासवर्ड की पुष्टि",
  "account.nameTips": "खाता नाम दर्ज करें",
  "account.passwordModifySuccess": "पासवर्ड बदलने में सफलता हुई",
  "account.emailCode": "ईमेल प्रमाणीकरण कोड",
  "account.emailCodeTips": "ईमेल प्रमाणीकरण कोड दर्ज करें",
  "account.emailCodeTips2": "अमान्य ईमेल प्रमाणीकरण कोड",
  "account.emailModifySuccess": "पासवर्ड बदलने में सफलता हुई",
  "account.passworTips1": "आपका पासवर्ड पुनर्प्राप्त किया गया है!",
  "account.passwordTips11": "पासवर्ड की पुष्टि के लिए दर्ज करें",
  "account.passwordTips12": "नया पासवर्ड दर्ज करें",
  "account.nickname": "उपनाम",
  "account.modifyNickname": "उपनाम बदलें",
  "account.modifyNicknameSuccess": "उपनाम बदलने में सफलता हुई!",
  "account.nicknameTips": "उपनाम दर्ज करें",
  "account.nicknameError": "उपनाम बदलने में विफलता हुई!",

  // त्वरित पंजीकरण और लॉगिन
  "account.login": "लॉगिन",
  "account.quickRegister": "त्वरित पंजीकरण",
  "account.sendCode": "प्रमाणीकरण कोड भेजें",
  "account.sendTips": "s सेकंड के बाद फिर से भेजा जा सकता है",
  "account.sendEmailIng": "ईमेल भेज रहा हूं... कृपया प्रतीक्षा करें...",
  "account.emailNotEmpty": "ईमेल फील्ड खाली नहीं रह सकता",
  "account.registerAccount": "खाता पंजीकरण",
  "account.registerWelcome": "SusprSafe पंजीकरण में आपका स्वागत है",
  "account.usernameLimit": "उपयोगकर्ता नाम का प्रारम्भ अक्षर से होना चाहिए, यह केवल अक्षर, संख्याएं और अंडरस्कोर (_) शामिल कर सकता है, लंबाई 5-15 वर्ण होनी चाहिए",

  // कॉपीराइट जानकारी
  "copyright.desc2": "वेबसाइट पंजीकरण जानकारी: ग्वांगडोंग प्रांत का ICP पंजीकरण नंबर 2021169764",

  // उपयोगकर्ता जानकारी संपादित करना
  "editUserInfo.editUserInformation": "उपयोगकर्ता जानकारी संपादित करें",
  "editUserInfo.modifyUsername": "उपयोगकर्ता नाम बदलें",
  "editUserInfo.changePictures": "प्रोफ़ाइल फोटो बदलें",
  "editUserInfo.savePicturesSuccess": "प्रोफ़ाइल फोटो सहेजने में सफलता हुई",
  "editUserInfo.saveError": "सहेजने में विफलता हुई",
  "editUserInfo.pictureLimit": "फोटो का आकार 2 MB से अधिक नहीं हो सकता",
  "editUserInfo.uploadPicture": "प्रोफ़ाइल फोटो अपलोड करें",
  "editUserInfo.picturePreview": "पूर्वावलोकन",
  
  "editUserInfo.bindPhoneNumber": "फोन नंबर बांधें",
  "editUserInfo.bindEmail": "ईमेल बांधें",
  "editUserInfo.changePassword": "पासवर्ड बदलें",

  "editUserInfo.notificationSettings": "सूचना सेटिंग्स",
  "editUserInfo.editAccount": "खाता जानकारी संपादित करें",
  "editUserInfo.waitBingting": "बांध रहा हूं... कृपया प्रतीक्षा करें...",
  "editUserInfo.collapse": "संकुचित करें (पृथक्करण)",
  "editUserInfo.modifyBinding": "बाइंडिंग बदलें",
  
  "editUserInfo.emailAddress": "ईमेल पता",
  "editUserInfo.tips1": "ईमेल बांधने में सफलता हुई",
  "editUserInfo.tips2": "सहेजने में विफलता हुई",
  "editUserInfo.tips3": "ईमेल प्रमाणीकरण कोड भेज रहा हूं... कृपया प्रतीक्षा करें...",
  "editUserInfo.tips4": "प्रमाणीकरण कोड xxxx ईमेल पर भेजा गया है, कृपया जांचें",
  "editUserInfo.tips5": "प्रमाणीकरण कोड भेजने में विफलता हुई!",
  "editUserInfo.tips6": "फोन नंबर बांधा गया है",
  "editUserInfo.tips7": "ईमेल बांधा गया है",
  "editUserInfo.emailTips1": "ईमेल पता दर्ज करें",
  "editUserInfo.emailTips2": "अमान्य ईमेल प्रारूप",
  "editUserInfo.emailTips3": "xxxx सेकंड के बाद फिर से भेजा जा सकता है",
  "editUserInfo.emailTips4": "प्रमाणीकरण कोड भेजें",
  "editUserInfo.emailTips5": "ईमेल प्रमाणीकरण कोड फील्ड खाली नहीं रह सकता",
  "editUserInfo.emailTips6": "अमान्य ईमेल प्रमाणीकरण कोड",
  "editUserInfo.emailCode": "ईमेल प्रमाणीकरण कोड",
  "editUserInfo.save": "सहेजें",

  // फोन बाइंडिंग से संबंधित
  "editUserInfo.phoneTips1": "फोन नंबर बांधने में सफलता हुई",
  "editUserInfo.phoneTips2": "SMS प्रमाणीकरण कोड भेज रहा हूं... कृपया प्रतीक्षा करें...",
  "editUserInfo.phoneTips3": "SMS प्रमाणीकरण कोड xxxx नंबर पर भेजा गया है, कृपया जांचें",
  "editUserInfo.phoneTips4": "SMS प्रमाणीकरण कोड भेजने में विफलता हुई!",
  "editUserInfo.phoneTips5": "फोन नंबर दर्ज करें",
  "editUserInfo.phoneTips6": "अमान्य फोन नंबर प्रारूप",
  "editUserInfo.phoneTips7": "SMS प्रमाणीकरण कोड भेजें",
  "editUserInfo.phoneTips8": "SMS प्रमाणीकरण कोड",
  "editUserInfo.phoneTips9": "SMS प्रमाणीकरण कोड फील्ड खाली नहीं रह सकता",
  "editUserInfo.phoneTips10": "अमान्य SMS प्रमाणीकरण कोड",
  "editUserInfo.phone": "फोन नंबर",


  // सूचना सेटिंग्स
  "editUserInfo.noticeTips1": "सूचना सेटिंग्स प्राप्त करने में विफलता हुई!",
  "editUserInfo.noticeTips2": "सूचना सेटिंग्स सहेजने में सफलता हुई!",
  "editUserInfo.noticeTips3": "बैटरी स्तर कम होने की सूचना",
  "editUserInfo.noticeTips4": "चार्ज पूरा होने की सूचना",
  "editUserInfo.errorNotification": "त्रुटि सूचना",
  "editUserInfo.updateNotification": "अपडेट सूचना",
  "editUserInfo.monthlyStatisticsNotification": "मासिक स्टेटिस्टिक्स सूचना",
  "editUserInfo.notificationMethod": "प्राप्ति तरीका",

  // उपयोगकर्ता नाम से संबंधित सुझाव
  "editUserInfo.userNameTips1": "उपयोगकर्ता नाम सहेजने में सफलता हुई",
  "editUserInfo.userNameTips2": "उपयोगकर्ता नाम सहेजने में विफलता हुई",
  "editUserInfo.userNameTips3": "उपयोगकर्ता नाम दर्ज करें",
  "editUserInfo.userNameTips4": "अमान्य उपयोगकर्ता नाम प्रारूप: केवल संख्याएं, अंडरस्कोर (_) और अंग्रेजी अक्षर शामिल कर सकता है",
  "editUserInfo.userNameTips5": "उपयोगकर्ता नाम दर्ज करें",
  "editUserInfo.userNameTips6": "सहेज रहा हूं... कृपया प्रतीक्षा करें...",
  "editUserInfo.userName": "उपयोगकर्ता नाम",

  // प्रोफ़ाइल फोटो संपादन सुझाव
  "editUserInfo.avatorTips": "प्रोफ़ाइल फोटो बदलने के लिए क्लिक करें",
  "editUserInfo.verifyCodeTips1": "प्राप्त प्रमाणीकरण कोड दर्ज करें:",
  "editUserInfo.verifyCodeTips2": "अपने खाते की सुरक्षा के लिए नीचे दिए गए बटन को क्लिक करें और प्रमाणीकरण कोड को मूल फोन नंबर पर भेजें:",
  "editUserInfo.verifyCodeTips3": "प्रमाणीकरण कोड भेजें",
  "editUserInfo.verifyCodeTips4": "मूल फोन नंबर का प्रमाणीकरण सफल हुआ, बांधने के लिए नया फोन नंबर दर्ज करें",
  "editUserInfo.verifyCodeTips5": "अपने खाते की सुरक्षा के लिए नीचे दिए गए बटन को क्लिक करें और प्रमाणीकरण कोड को मूल ईमेल पर भेजें:",
  "editUserInfo.verifyCodeTips6": "मूल ईमेल का प्रमाणीकरण सफल हुआ, नया ईमेल दर्ज करें",
  "editUserInfo.verifyCodeTips7": "पुराना पासवर्ड",
  "editUserInfo.verifyCodeTips8": "पहले ईमेल को बांधें!",
  "editUserInfo.verifyCodeTips9": "प्रमाणीकरण कोड ईमेल पर भेजा गया है, कृपया जांचें",
  "editUserInfo.verifyCodeTips10": ", स्वचालित रूप से लॉगिन पृष्ठ पर जाएगा",

  // सूचना से संबंधित
  "hems.notice.title": "सूचना शीर्षक", 
  "hems.notice.content": "सूचना सामग्री", 
  "hems.notice.operate": "ऑपरेशन",
  "hems.notice.noRead": "अपढ़ा",
  "hems.notice.read": "पढ़ा हुआ",
  "hems.notice.warning": "चेतावनी",
  "hems.notice.error": "त्रुटि",
  "hems.notice.success": "स्टेटिस्टिक्स गणना",
  "hems.notice.sys": "सिस्टम जानकारी",
  "hems.notice.operateSuccess": "ऑपरेशन सफल हुआ",
  "hems.notice.operateTips": "ऑपरेशन के लिए तत्व चुनें",

  // होम पेज
  "hems.home.selfuseRate": "स्वयं उपयोग प्रतिशत",
  "hems.home.percent": "प्रतिशत",
  "hems.home.todayData": "आज का डेटा",
  "hems.home.todayPowerGeneration": "आज का विद्युत उत्पादन",
  "hems.home.salesIncome": "विद्युत बिक्री से आय",
  "hems.home.saved": "आपने बचाया है",
  "hems.home.reduce": "कार्बन उत्सर्जन कमी",
  "hems.home.tips1": "वर्तमान में डेटा उपलब्ध नहीं है, आपने अभी तक xxxx को बांधा नहीं है",
  "hems.home.criticalLoad": "क्रिटिकल लोड",
  "hems.home.keyVoltage": "क्रिटिकल वोल्टेज",
  "hems.home.householdLoad": "घरेलू लोड",
  "hems.home.householdVoltage": "घरेलू वोल्टेज",
  "hems.home.generalLoad": "सामान्य लोड",
  "hems.home.generalVoltage": "सामान्य वोल्टेज",
  "hems.home.batteryHealth": "बैटरी स्वास्थ्य स्थिति",
  "hems.home.averageTemp": "औसत तापमान",
  "hems.home.gridLoad": "विद्युत ग्रिड लोड",
  "hems.home.toggeleDataSource": "दिखाए गए डेटा को निम्नानुसार बदल दिया गया है:",
  "hems.home.toggleTips": "क्या आप बदलना चाहते हैं?",
  "hems.home.modeSending": "मोड कमांड भेज रहा हूं... कृपया प्रतीक्षा करें...",
  "hems.home.modeSuccess": "मोड बदलने का कमांड सफलतापूर्वक भेजा गया!",
  "hems.home.isOnline": "क्या आप ऑनलाइन हैं?",
  "hems.home.useStatus": "उपयोग स्थिति",
  "hems.home.workModeText": "वर्तमान कार्य मोड:",
  "hems.home.toggleDataSourceText": "दिखाए गए डेटा को निम्नानुसार बदल दिया गया है:",
  "hems.ev.charge.status": "चार्ज स्थिति",
  "hems.ev.charge.time": "चार्ज समय",
  "hems.ev.charge.count": "वास्तविक चार्ज संख्या (समय के साथ)",
  "hems.ev.charge.status.empty": "खाली",
  "hems.ev.charge.status.ing": "बैटरी से जुड़ा हुआ है। चार्ज हो रहा है",
  "hems.ev.charge.status.null": "बैटरी से जुड़ा हुआ है, लेकिन चार्ज नहीं हो रहा",
  "hems.ev.charge.status.error": "त्रुटि",
  "hems.hour": "घंटा",
  "hems.minue": "मिनट",
  "hems.ev.chagre.number": "चार्जर नंबर",

  // उपयोगकर्ता गाइड
  "hems.userGuide.selfUse": "स्वयं उत्पन्न ऊर्जा का उपयोग",
  "hems.userGuide.selfUseTips": "पहले सौर ऊर्जा का उपयोग करें, यदि यह पर्याप्त नहीं है, तो विद्युत ग्रिड से पूरा करें",
  "hems.userGuide.economyMode": "अर्थव्यवस्थिक मोड",
  "hems.userGuide.economyModeTips": "विद्युत की कीमतों के आधार पर ऊर्जा उपयोग रणनीति को इष्टतम बनाएं",
  "hems.userGuide.emergencyMode": "आपातकालीन मोड",
  "hems.userGuide.emergencyModeTips": "क्रिटिकल लोड के लिए ऊर्जा आपूर्ति को प्राथमिकता दें",

  // ग्राफ पृष्ठ
  "hems.history.energyStatistics": "ऊर्जा स्टेटिस्टिक्स",
  "hems.history.revenueStatistics": "आय स्टेटिस्टिक्स",
  "hems.history.greenStatistics": "हरित उत्सर्जन कमी",
  "hems.history.revenueTitle": "विद्युत बिक्री से कुल आय",
  "hems.history.savingsTitle": "कुल बचत",
  "hems.history.carbonTitle": "कुल कार्बन कमी",
  "hems.history.day": "दिन",
  "hems.history.month": "महीना",
  "hems.history.year": "वर्ष",
  "hems.history.beforeDay": "पिछला दिन",
  "hems.history.afterDay": "अगला दिन",
  "hems.history.beforeMonth": "पिछला महीना",
  "hems.history.afterMonth": "अगला महीना",
  "hems.history.beforeYear": "पिछला वर्ष",
  "hems.history.afterYear": "अगला वर्ष",
  "hems.history.totalUse": "कुल उपयोग",
  "hems.history.fullScreen": "पूर्ण स्क्रीन",
  "hems.history.timeSelect": "दिन चुनें",
  "sync.tips1": "डेटा सिंक्रोनाइजेशन कमांड सफलतापूर्वक भेजा गया!",
  "sync.tips2": "डेटा सिंक्रोनाइजेशन चल रहा है, बड़े डेटा के कारण यह समय ले रहा है, 50 मिनट के बाद फिर से जांचें~",
  "sync.tips3": "यदि डेटा में असंगति देखी जाती है, तो डिवाइस का डेटा सिंक्रोनाइजेशन देरी कर सकता है, नीचे दिए गए बटन को क्लिक करें:",
  "sync.tips4": "डेटा सिंक्रोनाइज़ करें",

  // चार्जर जानकारी
  "charge.info": "चार्जर जानकारी",
  "news.loading": "लोड हो रहा है...",
  "news.noMore": "अधिक डेटा नहीं है",
  "hems.pv.power": "सौर ऊर्जा मात्रा",

  // UEH विशेष कार्यक्षमता
  "ueh.sellPower": "बिक्री के लिए ऊर्जा मात्रा",
  
  // मेनू
  "menu.home": "होम पेज",
  "menu.history": "इतिहास डेटा",
  "menu.device": "उपकरण",
  "menu.settings": "सेटिंग्स",
  "menu.messageCenter": "संदेश केंद्र",
  "menu.help": "मदद और सहायता",
  "menu.mine": "मेरा (व्यक्तिगत)",


  // मेरी सेटिंग्स
  "mine.userSetting": "उपयोगकर्ता सेटिंग्स",
  "mine.terminalSetting": "मूल टर्मिनल सेटिंग्स",
  "mine.uploadCloud": "डेटा को क्लाउड में अपलोड करें",
  "mine.changeVersion": "अपडेट की जांच करें",
  "mine.language": "भाषा बदलें",
  "mine.about": "ऐप के बारे में",
  "mine.feedback": "प्रतिक्रिया",
  "mine.logout": "लॉगआउट",
  "mine.logoutAccount": "खाता हटा दें",

  // खाता हटाने से संबंधित
  "mine.logoutAccountTips": "नाम [] वाला खाता हटा दें",
  "mine.logoutAccountTips1": "[] से बांधा हुआ खाता हटा दें",
  "mine.logoutAccountCare": "खाता हटाने के अनुरोध के टिप्स:",
  "mine.logoutAccountCare1": "1. खाता सुरक्षित स्थिति में है",
  "mine.logoutAccountCare1-1": "खाता सामान्य उपयोग मोड में है, चोरी का जोखिम, नियमों का उल्लंघन या बंद होने का जोखिम नहीं है",
  "mine.logoutAccountCare2": "2. खाता एक्सेस और बाइंडिंग हटा दिए जाएंगे",
  "mine.logoutAccountCare2-1": "तीसरे पक्ष के प्लेटफार्मों के लिए सभी खाता एक्सेस अधिकार हटा दिए जाएंगे",
  "mine.logoutAccountCare3": "3. हटाने के बाद खाता पुनर्प्राप्त नहीं किया जा सकता, उपयोगकर्ता डेटा हटा दिए जाएंगे",
  "mine.logoutAccountCare3-1": "हटाने के बाद बांधे गए फोन नंबर, ईमेल और संबंधित डेटा हटा दिए जाएंगे और पुनर्प्राप्त नहीं किए जा सकते",
  "mine.confirmLogout": "हटाने की पुष्टि करें",
  "mine.logoutSuccess": "खाता सफलतापूर्वक हटा दिया गया!",


  // प्रतिक्रिया समस्याएं
  "mine.feedbackIssues": "समस्याएं और प्रतिक्रिया",
  "mine.feedQuantity": "मात्रा",
  "mine.feedAmount": "अधिकतम 9 फोटो, प्रत्येक फोटो का अधिकतम आकार 1 MB",

  // सूचना सेटिंग्स से संबंधित
  "mine.notice.fail": "सूचना सेटिंग्स प्राप्त करने में विफलता हुई!",
  "mine.notice.saveSuccess": "सूचना सेटिंग्स सहेजने में सफलता हुई!",
  "mine.notice.saveFail": "सहेजने में विफलता हुई!",
  "mine.notice.title": "सूचना सेटिंग्स",
  "mine.notice.batteryLow": "बैटरी स्तर कम होने की सूचना",
  "mine.notice.chargingFinish": "चार्ज पूरा होने की सूचना",
  "mine.notice.error": "त्रुटि सूचना",
  "mine.notice.update": "अपडेट सूचना",
  "mine.notice.monthly": "मासिक स्टेटिस्टिक्स सूचना",
  "mine.notice.receiveType": "प्राप्ति तरीका",

  // भाषा सेटिंग्स में स्वागत
  "mine.language.welcome": "SusprSafe में आपका स्वागत है",
  "mine.language.desc1": "अपने घर के पते के आधार पर भाषा संस्करण चुनें",
  "mine.language.desc2": "आप ऐप की सेटिंग्स में किसी भी समय इसे बदल सकते हैं",

  // व्यक्तिगत जानकारी
  "mine.userInfo.avatar": "प्रोफ़ाइल फोटो",
  "mine.userInfo.nickname": "उपनाम",
  "mine.userInfo.password": "पासवर्ड",
  "mine.userInfo.changePassword": "पासवर्ड बदलें",
  "mine.userInfo.setPassword": "पासवर्ड सेट करें",
  "mine.userInfo.phoneNumber": "फोन नंबर",
  "mine.userInfo.bindPhone": "फोन बांधें",
  "mine.userInfo.bindEmail": "ईमेल बांधें",
  "mine.loginExpired": "लॉगिन सत्र समाप्त हो गया है, फिर से लॉगिन करें",
  "mine.userInfo.title": "उपयोगकर्ता जानकारी",
  "mine.userInfo.bind": "बांधें",
  "mine.userInfo.modify": "संपादित करें",
  "mine.userInfo.modifyNickname": "उपनाम बदलें",
  "mine.userInfo.userNickname": "उपयोगकर्ता का उपनाम",
  "mine.userInfo.selectPic": "अपलोड के लिए फोटो चुनें",
  "mine.userInfo.saveSuccess": "सहेजने में सफलता हुई",
  "mine.userInfo.uploadFail": "अपलोड में विफलता हुई",
  "mine.userInfo.avatarSaveSuccess": "प्रोफ़ाइल फोटो सहेजने में सफलता हुई",
  "mine.userInfo.nameTips1": "उपनाम फील्ड खाली नहीं रह सकता",
  "mine.userInfo.nameTips2": "उपनाम दर्ज करें",

  // सामान्य चयन सुझाव
  "common.pleaseSelect": "चुनें",
  "question.commonQuestions": "अक्सर पूछे जाने वाले प्रश्न",
  "account.toggleLanguage": "भाषा बदलें",
  "account.localConnection": "स्थानीय कनेक्शन",
  "account.selectLanguage": "भाषा चुनें",
  "account.sendEmailToast": "प्रमाणीकरण कोड xxx ईमेल पर भेजा गया है, कृपया जांचें",
  "account.emailError": "अमान्य ईमेल प्रारूप",
  "account.sendEmailFail": "प्रस्तुत करने में विफलता हुई, फिर से प्रयास करें",
  
  "common.submitting": "प्रस्तुत कर रहा हूं... कृपया प्रतीक्षा करें...",

  "device.page.noData": "वर्तमान में डेटा उपलब्ध नहीं है, यह पृष्ठ केवल ऐप में दिखाया जा सकता है"
,

  // OTA Upgrade
  "bmsFirmware.upgrade": "Upgrade",
  "bmsFirmware.upgrading": "Upgrading...",
  "bmsFirmware.uploadingFile": "Uploading firmware file...",
  "bmsFirmware.upgradingProgress": "Upgrading firmware... {progress}%",
  "bmsFirmware.upgradeSuccess": "Upgrade Successful",
  "bmsFirmware.upgradeSuccessSubtitle": "BMS firmware upgrade completed!",
  "bmsFirmware.upgradeFailed": "Upgrade Failed",
  "bmsFirmware.upgradeFailedFormError": "Please check if the form is filled correctly",
  "bmsFirmware.upgradeFailedNetworkError": "Network error, please retry",
  "bmsFirmware.invalidFileType": "Please select a valid firmware file (.bin, .hex, .fw, .firmware)",
  "bmsFirmware.selectFileWarning": "Please select a firmware file first",
  "bmsFirmware.statusUpgrading": "Upgrading",
  "bmsFirmware.statusCompleted": "Upgrade Completed",
  "bmsFirmware.statusFailed": "Upgrade Failed",
  "bmsFirmware.deviceUpgrading": "Upgrading firmware package, upgrade takes 30 ~ 50 minutes, real-time device data cannot be viewed during this period, please wait...",
  "bmsFirmware.upgradeStatusLabel": "Upgrade Status",
  "bmsFirmware.upgradeProgressLabel": "Upgrade Progress",
  "bmsFirmware.currentPackageLabel": "Current transmitted data package number",
  "bmsFirmware.totalPackagesLabel": "Total data packages",
  "bmsFirmware.upgradeFailedCheckDevice": "Please check device status and retry upgrade",

  // Setting Result Dialog Translations
  "settingResult.defaultTitle": "Setting Successful",
  "settingResult.defaultSubTitle": "Parameter settings saved",
  "settingResult.confirmButton": "OK"
};